import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import {DropzoneArea} from 'material-ui-dropzone';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@material-ui/core';
import { globalPutService, globalPostService, globalGetService } from '../../../globalServices';
import { checkApiStatus } from '../../utils_v2';
import { trackActivity } from '../../../utils/mixpanel';
import { hanwahaInstance, jetStreamInstance } from '../../../shared/components';
import { Autocomplete } from '@material-ui/lab';
import InfoIcon from '@material-ui/icons/Info';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
const AddEditInventory = ({addEditInventory, toggleModalFn, getResponseBack, onOpenAttachments, assetTypes, strandTypes, pltConstants}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [inventory, setInventory] = useState(addEditInventory.data);
    const [error, setError] = useState({});
    const onFieldChange = (key, value) => {
        if(key === 'linked_asset_detail'){
            if(value){
                if(value?.id == null){
                    setInventory({...inventory,[key]:value, reference:'', asset_name: '', seller: '', lessee: '', asset_location: '', asset_status: '' });
                }else{
                    setInventory({...inventory,[key]:value, reference:'', asset_name: value?.asset_name, seller: value?.seller, lessee: value?.lessee, asset_location: value?.location, asset_status: value?.wing_status });
                }
            }else{
                setInventory({...inventory,[key]:value, linked_asset:'', reference:'', asset_name: '', seller: '', lessee: '', asset_location: '', asset_status: '' });
            }
        }else{
            setInventory({...inventory,[key]:value});
        }
    }
    const uploadAttachments = (id, files, type) => {
        var formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            formData.append('files', file, file.name);
        }
        globalPostService(`console/attachments/inventory/${id}/`,formData)
        .then(response => {
            if(checkApiStatus(response)){
                enqueueSnackbar(type === 'add' ?'Inventory added successfully':'Inventory updated successfully', { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                toggleModalFn(); getResponseBack();
                trackActivity('Console Management', { page_title: 'Inventories', item_type: 'Upload Attachment', event_type: 'Add/Edit Inventory Modal', event_desc: `${type === 'add' ? 'Inventory added successfully':'Inventory updated successfully'}`, item_id: id, form_data: formData});
            }
            setLoading(false);
        })
    }
    const onAddEditInventory = () => {
        let validationInputs = {};
        validationInputs = {
            description:inventory?.description?.trim()?.length ? '':'Please enter Description',
            serial_number:inventory?.serial_number?.trim()?.length ? '':'Please enter Serial Number',
            reference: !hanwahaInstance ? '': inventory?.linked_asset_detail?.id ? '': inventory?.reference?.trim()?.length ? '': inventory?.linked_asset_detail?.asset_name ==='Other (External / Not in SPARTA)' || inventory?.linked_asset ==='Other (External / Not in SPARTA)' ?'Please enter Reference':'',
            inventory_type: !hanwahaInstance ? '': inventory?.inventory_type ? '': 'Please select Inventory type'
        }
        if(Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            let payload = Object.assign({}, inventory)
            if(hanwahaInstance){
                payload ={
                    ...payload,
                    linked_asset: payload?.linked_asset_detail?.asset_name || payload?.linked_asset_detail || payload?.linked_asset,
                    asset_status: payload?.asset_status?.value || payload?.asset_status,
                    linked_asset_type: payload?.linked_asset_detail?.asset_type || null,
                    linked_asset_id: payload?.linked_asset_detail?.id,
                    inventory_type: payload?.inventory_type?.id || payload?.inventory_type,
                }
            }
            if(inventory.id){
                globalPutService(`console/inventory/${inventory.id}/`, payload)
                .then(response => {
                    if(checkApiStatus(response)){
                        if(inventory?.files?.length){
                            uploadAttachments(inventory.id, inventory.files, 'edit');
                            trackActivity('Console Management', { page_title: 'Inventories', item_type: 'Edit', event_type:'Edit Inventory Modal-Upload Attachment', event_desc: 'Upload Attachment Edited', item_id: inventory?.id, item_data:inventory?.files });
                        }else{
                            enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                            toggleModalFn(); getResponseBack();
                            trackActivity('Console Management', { page_title: 'Inventories', item_type: 'Edit', event_type:'Edit Inventory Modal', event_desc: 'Inventories Edited', item_id: inventory?.id, item_data:JSON.stringify(inventory), response_msg:response?.data?.message });
                        }
                    }else{
                        setLoading(false);
                    }
                })
            }else{
                globalPostService(`console/inventory/`, payload)
                .then(response => {
                    if(checkApiStatus(response)){   
                        if(inventory?.files?.length){
                            uploadAttachments(response.data.data.id, inventory.files, 'add');
                            trackActivity('Console Management', { page_title: ' Inventories', item_type: 'Add', event_type: 'Add Inventory Modal- Upload Attachment', event_desc: 'Upload Attachment Added', item_id: response?.data?.data?.id, item_data:inventory?.files });
                        }else{
                            enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                            toggleModalFn(); getResponseBack();
                            trackActivity('Console Management', { page_title: 'Inventories', item_type: 'Add', event_type:'Add Inventory Modal', event_desc: 'Inventories Added', item_data:inventory, response_msg:response?.data?.message });
                        }
                    }else{
                        setLoading(false);
                    }
                })
            }
        }else{
            setError(validationInputs)
        }
    }
    console.log('inventory',inventory);
    
    return(
        <>
            <Dialog
                open={addEditInventory.modal}
                onClose={() => toggleModalFn()}
                className='console-management-modal'
                maxWidth={'md'}
            >
                <DialogTitle id="scroll-dialog-title">
                    {inventory.id ? addEditInventory.mode === 'view' ?'View':'Edit':'Add'} Inventory
                </DialogTitle>
                <DialogContent dividers={true}>
                    <form>
                        <Grid container spacing={1}>
                            <Grid item md={4}>
                                <TextField
                                    disabled={addEditInventory.mode === 'view'}
                                    required
                                    name="description"
                                    label="Description"
                                    fullWidth
                                    margin="normal"
                                    value={inventory.description}
                                    error={error.description ? true : false}
                                    helperText={error.description ? error.description : ''}
                                    onChange={(e, value) => onFieldChange('description', e.target.value)}
                                    onFocus={() => setError({...error,'description':''})}
                                    inputProps={{ maxLength: 50 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={4}>
                                <TextField
                                    disabled={addEditInventory.mode === 'view'}
                                    required
                                    name="serial_number"
                                    label="Serial Number"
                                    fullWidth
                                    margin="normal"
                                    value={inventory.serial_number}
                                    error={error.serial_number ? true : false}
                                    helperText={error.serial_number ? error.serial_number : ''}
                                    onChange={(e, value) => onFieldChange('serial_number', e.target.value)}
                                    onFocus={() => setError({...error,'serial_number':''})}
                                    inputProps={{ maxLength: 50 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={4}>
                                <TextField
                                    disabled={addEditInventory.mode === 'view'}
                                    name="part_number"
                                    label="Part Number"
                                    fullWidth
                                    margin="normal"
                                    value={inventory.part_number}
                                    onChange={(e, value) => onFieldChange('part_number', e.target.value)}
                                    inputProps={{ maxLength: 50 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            {hanwahaInstance ?
                             <Grid item md={4}>
                                   <Autocomplete
                                    required
                                    options={strandTypes}
                                    getOptionLabel={option => option?.name || ''}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    id="inventory_type"
                                    disabled={addEditInventory.mode === 'view'}
                                    value={inventory?.inventory_type || null}
                                    onChange={(e, value) => onFieldChange('inventory_type', value)}
                                    renderInput={params => <TextField {...params} label={'Type'} error={error?.inventory_type || ''} helperText={error?.inventory_type || ''} margin="normal" required fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    onFocus={() => setError({ ...error, inventory_type: '' })}
                                /> </Grid>
                                :null}
                            <Grid item md={4}>
                                <TextField
                                    disabled={addEditInventory.mode === 'view'}
                                    name="owner"
                                    label={jetStreamInstance?"Owner/SPV":"Owner"}
                                    fullWidth
                                    margin="normal"
                                    value={inventory.owner}
                                    onChange={(e, value) => onFieldChange('owner', e.target.value)}
                                    inputProps={{ maxLength: 50 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={4}>
                                <TextField
                                    disabled={addEditInventory.mode === 'view'}
                                    name="location"
                                    label="Location"
                                    fullWidth
                                    margin="normal"
                                    value={inventory.location}
                                    onChange={(e, value) => onFieldChange('location', e.target.value)}
                                    inputProps={{ maxLength: 50 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                              {hanwahaInstance ?
                             <Grid item md={12}>
                                   <Autocomplete
                                    options={[...assetTypes, {asset_name:'Other (External / Not in SPARTA)', id:null}]}
                                    getOptionLabel={option => option?.asset_name || ''}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    id="linked_asset_detail"
                                    disabled={addEditInventory.mode === 'view'}
                                    value={inventory?.linked_asset_detail?.id ? inventory.linked_asset_detail : (inventory?.linked_asset_detail?.asset_name=='Other (External / Not in SPARTA)' || inventory?.linked_asset=='Other (External / Not in SPARTA)' ? {asset_name:'Other (External / Not in SPARTA)', id:null} : null)}
                                    onChange={(e, value) => onFieldChange('linked_asset_detail', value)}
                                    renderInput={params => <TextField {...params} label={<div style={{display:'inline-flex', width:'max-content'}}>Linked Asset <div style={{color:'gray'}}> &nbsp; (Select SPARTA asset or choose Other)</div></div> } error={error?.linked_asset_detail || ''} helperText={error?.linked_asset_detail || ''} margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    onFocus={() => setError({ ...error, linked_asset_detail: '' })}
                                /> </Grid>
                                :null}
                            {
                                hanwahaInstance ?
                                 <Grid item md={12}>
                                    <div style={{ backgroundColor: '#f5f5f5', borderRadius: 4, padding: 16 }}>
                                        <Grid container spacing={1}>
                                            {inventory?.linked_asset_detail?.id ?
                                            <Grid item md={12}> <div style={{ display: 'flex', alignItems: 'center', color: '#2e7d32' }}> <CheckCircleIcon fontSize='small' style={{ marginRight: 6 }} /> Auto populated from {inventory.linked_asset_detail?.asset_name || ''} Tech Specs -- read only</div> </Grid>

                                            : (inventory?.linked_asset_detail?.asset_name ==='Other (External / Not in SPARTA)' || inventory?.linked_asset ==='Other (External / Not in SPARTA)')?
                                           <> <div style={{ display: 'flex', alignItems: 'center', color: '#B36543' }}> <InfoIcon fontSize='small' style={{ marginRight: 6 }} /> Asset {addEditInventory.mode === 'view' ? 'details entered manually, click edit to change details.': 'not in SPARTA. Enter details manually.'} </div>
                                            <Grid item md={12}>
                                                <TextField
                                                    required
                                                    disabled={addEditInventory.mode === 'view' || inventory?.linked_asset_detail?.id}
                                                    name="reference"
                                                    label="Asset/Engine Reference"
                                                    fullWidth
                                                    margin="normal"
                                                    value={inventory.reference || ''}
                                                    onChange={(e, value) => onFieldChange('reference', e.target.value)}
                                                    inputProps={{ maxLength: 255 }}
                                                    InputLabelProps={{ shrink: true }}
                                                    error={error.reference ? true : false}
                                                    helperText={error.reference ? error.reference : ''}
                                                    onFocus={() => setError({...error,'reference':''})}
                                                    variant='outlined'
                                                />
                                            </Grid></>:null}
                                            <Grid item md={6}>
                                                <TextField
                                                    disabled={addEditInventory.mode === 'view' || inventory?.linked_asset_detail?.id}
                                                    name="seller"
                                                    label="Seller"
                                                    fullWidth
                                                    margin="normal"
                                                    value={inventory.seller || ''}
                                                    onChange={(e, value) => onFieldChange('seller', e.target.value)}
                                                    inputProps={{ maxLength: 255 }}
                                                    InputLabelProps={{ shrink: true }}
                                                    variant='outlined'
                                                />
                                            </Grid>
                                            <Grid item md={6}>
                                                <TextField
                                                    disabled={addEditInventory.mode === 'view' || inventory?.linked_asset_detail?.id}
                                                    name="lessee"
                                                    label="Lessee"
                                                    fullWidth
                                                    margin="normal"
                                                    value={inventory.lessee || ''}
                                                    onChange={(e, value) => onFieldChange('lessee', e.target.value)}
                                                    inputProps={{ maxLength: 255 }}
                                                    InputLabelProps={{ shrink: true }}
                                                    variant='outlined'
                                                />
                                            </Grid>
                                            <Grid item md={6}>
                                                <TextField
                                                    disabled={addEditInventory.mode === 'view' || inventory?.linked_asset_detail?.id}
                                                    name="asset_location"
                                                    label="Asset Location"
                                                    fullWidth
                                                    margin="normal"
                                                    value={inventory.asset_location || ''}
                                                    onChange={(e, value) => onFieldChange('asset_location', e.target.value)}
                                                    inputProps={{ maxLength: 255 }}
                                                    InputLabelProps={{ shrink: true }}
                                                    variant='outlined'
                                                />
                                            </Grid>
                                                <Grid item md={6}>
                                                    <Autocomplete
                                                        options={pltConstants}
                                                        getOptionLabel={option => option?.label || ''}
                                                        isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                                        id="asset_status"
                                                        disabled={addEditInventory.mode === 'view' || inventory?.linked_asset_detail?.id}
                                                        value={pltConstants?.find(i => i?.value == (inventory?.linked_asset_detail?.wing_status || inventory?.asset_status?.value || inventory?.asset_status)) || null}
                                                        onChange={(e, value) => onFieldChange('asset_status', value)}
                                                        renderInput={params => <TextField {...params} label={'Asset Status'} margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                                    />
                                            </Grid>
                                        </Grid>
                                    </div> 
                                    </Grid>
                                    : null}
                                    {hanwahaInstance?null:
                            <Grid item md={4}>
                                <TextField
                                    disabled={addEditInventory.mode === 'view'}
                                    name="linked_asset"
                                    label="Linked Asset"
                                    fullWidth
                                    margin="normal"
                                    value={inventory.linked_asset}
                                    onChange={(e, value) => onFieldChange('linked_asset', e.target.value)}
                                    inputProps={{ maxLength: 50 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>}
                             {hanwahaInstance?null:
                            <Grid item md={4}>
                                <TextField
                                    disabled={addEditInventory.mode === 'view'}
                                    name="status"
                                    label="Status"
                                    fullWidth
                                    margin="normal"
                                    value={inventory.status}
                                    onChange={(e, value) => onFieldChange('status', e.target.value)}
                                    inputProps={{ maxLength: 50 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>}
                            <Grid item md={12}>
                                <TextField
                                    disabled={addEditInventory.mode === 'view'}
                                    name="remarks"
                                    label="Remarks"
                                    fullWidth
                                    multiline
                                    minRows={4}
                                    margin="normal"
                                    value={inventory.remarks}
                                    onChange={(e, value) => onFieldChange('remarks', e.target.value)}
                                    inputProps={{ maxLength: 255 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={12}>
                                { inventory.id && addEditInventory?.data?.attachments?.length ?
                                    <Button onClick={onOpenAttachments} size='small' variant='outlined' color='primary'>({addEditInventory.data.attachments.length})Attachment(s)</Button>:null
                                }
                                { addEditInventory.mode !== 'view' ?
                                    <>
                                        <div>
                                            <DropzoneArea
                                                acceptedFiles={['.png, .jpg, .jpeg, .pdf, .xls, .xlsx, .doc, .docx']}
                                                filesLimit={10}
                                                maxFileSize={104857600}
                                                showPreviewsInDropzone={false}
                                                useChipsForPreview={true}
                                                showPreviews={ true }
                                                dropzoneText={<p style={{fontSize:'13px'}}>Drag & Drop Documents<br/> OR <br/> Click Here<br/> </p>}
                                                dropzoneClass="drag-drop-cnt"
                                                maxWidth="sm"
                                                showAlerts={['info','error']}
                                                alertSnackbarProps={{anchorOrigin: {vertical:'top', horizontal:'right'}}}
                                                clearOnUnmount={true}
                                                onChange={(files) => onFieldChange('files',files)} 
                                            />
                                        </div>
                                        <span style={{fontSize:'11px'}} className='files-upload-limit' > Note : Max files upload limit is 10 in single time, with supported extension ('.png, .jpg, .jpeg, .pdf, .xls, .xlsx, .doc, .docx').</span>
                                    </>:null
                                }
                            </Grid>
                        </Grid> 
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button disabled={isLoading} color="primary" size='small' variant='outlined' onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Inventories', item_type: 'Add/Edit Inventories Modal', event_type:'Item Clicked', event_desc: 'Clicked on Cancel Button' }) }}>{addEditInventory.mode === 'view' ? 'Close' : 'Cancel'}</Button>
                    { addEditInventory.mode !== 'view' ?
                        <Button disabled={isLoading} size='small' color="primary"  variant="contained" onClick={() => { onAddEditInventory(); trackActivity('Console Management', { page_title: 'Inventories', item_type: 'Item Clicked', event_type: 'Add/Edit Inventories Modal', event_desc: 'Clicked on Save Button' }) }}>
                            {isLoading ? <CircularProgress color="#ffffff" size={24} /> : 'Save'}
                        </Button>:null
                    }
                </DialogActions>
            </Dialog>
        </>
    )
}
export default AddEditInventory;